Librarian.GridWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["search", "onLoadData", "onRowCheck", "isSelected", "findSelected", "onDoubleClick", "onCancel", "onSubmit"],

    options: {
        id: "GridWindow",
        title: "",
        width: 650,
        height: 570,
        limit: 0,

        selection: true,
        selected: null,

        searchable: true,

        // The name of the property which is a unique identifier for each item
        // Used for finding items in selected list
        uidField: "name",

        gridOptions: {
            columnModel: [
                {
                    header: Librarian.Lang.getString("name"),
                    dataIndex: "name",
                    dataType: "string",
                    width: 225
                }
            ],
            url: null,
            multipleSelection: false,
            resizable: false,
            pagination: true,
            serverSort: false,
            sortHeader: true,
            perPage: 20,
            width: 625,
            height: 480
        }
    },

    gridEl: null,
    grid: null,
    selected: [],

    initialize: function (options) {
        this.setOptions(options);

        if (typeOf(this.options.selected) == "array")
            this.selected = this.options.selected;

        if (!this.options.contentURL)
            this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/grid.html";

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.parent();
        this.setupElements();

        var itemEl = this.gridEl = this.getElement("gridPanel");
        if (itemEl) {
            this.grid = new omniGrid(itemEl.id, this.options.gridOptions);

            this.grid.addEvent("loaddata", this.onLoadData);
            this.grid.addEvent("dblclick", this.onDoubleClick);
            this.grid.onSelect = this.onRowCheck;
        }

        this.setupHeader();

        itemEl = this.getElement("cancelButton");
        if (itemEl) {
            if (!this.options.selection)
                itemEl.value = "Close";

            itemEl.addOnClick(this.close);
        }

        itemEl = this.getElement("okButton");
        if (itemEl) {
            if (!this.options.selection)
                itemEl.destroy();
            else
                itemEl.addOnClick(this.onSubmit);
        }
    },

    setupHeader: function () {
        var self = this,
            filterEls = this.windowEl.getElements("a.filterLetter");
        for (var i = 0; i < filterEls.length; i++) {
            filterEls[i].addOnClick(function() {
                var term = this.get("text");
                if (term == "All")
                    term = null;
                else
                    term += '%';

                self.search(term, false);
            });
        }

        if (this.options.searchable) {
            var itemEl = this.getElement("filterButton");
            if (itemEl) {
                itemEl.addOnClick(function () {
                    itemEl = this.getElement("filterTextBox");
                    if (itemEl)
                        this.search(itemEl.value);
                }.bind(this));
            }

            itemEl = this.getElement("filterTextBox");
            if (itemEl) {
                itemEl.addEvent("keypress",
                    function (e) {
                        var evt = new Event(e);
                        if (evt.keyCode == 13) {
                            itemEl = this.getElement("filterTextBox");
                            if (itemEl)
                                this.search(itemEl.value);
                            evt.stop();
                            return false;
                        }
                    }.bind(this));
            }
        } else {
            var itemEl = this.getElement("filterContainer");
            if (itemEl) {
                itemEl.hide();
            }
        }
    },

    isMultiSelect: function () {
        return (this.grid.options.columnModel.some(function (column) {
            return column.dataType == "checkbox";
        }));
    },

    search: function (value, useParameters) {
        value = this.formatSearchValue(value);

        var params = this.getSearchParams(value);
        if ((params == null) || (useParameters === false))
            this.grid.search(value);
        else {
            params.nameFilter = value;

            this.grid.searchWithOptions(params);
        }
    },

    // Override to include % wildcards
    formatSearchValue: function (value) {
        return value;
    },

    getSearchParams: function (value) {
        return null;
    },

    onLoadData: $empty,
    onDoubleClick: function () {
        if (!this.options.selection)
            return;

        if (this.isMultiSelect())
            return;

        this.onSubmit();
    },

    onRowCheck: function (obj) {
        var data = this.grid.getDataByRow(obj.row),
            index = this.findSelected(data);

        if (obj.input.checked && (index == -1)) {
            if ((this.options.limit > 0) && (this.selected.length >= this.options.limit)) {
                Librarian.Utils.error(Librarian.Lang.getArgString("limit_reached", this.options.limit));
                // Uncheck the check box
                if (obj.input)
                    $(obj.input).set("checked", false);
            }
            else
                this.selected.push(data);
        }
        else if (!obj.input.checked && (index >= 0))
            this.selected.remove(index);
    },

    isSelected: function (row) {
        var data = this.grid.getDataByRow(row);
        return this.findSelected(data) != -1;
    },

    findSelected: function (data) {
        var uid = this.options.uidField;
        for (var i = 0, length = this.selected.length; i < length; i++) {
            var item = this.selected[i];
            if (item[uid] == data[uid])
                return i;
        }

        return -1;
    },

    onSubmit: function () {
        var data;
        if (this.isMultiSelect())
            data = this.selected;
        else
            data = this.grid.getDataByRow(this.grid.selected[0]);

        if (data)
            this.fireEvent("complete", [data]);

        this.close();
    }
});